<template>

  <b-overlay
    id="overfix"
    :show="loader.screen"
  >
    <template
      #overlay
    >
      <div class="text-center">
        <feather-icon
          icon="ClockIcon"
          size="30"
        />
        <h4 id="cancel-label">
          Por favor espere...
        </h4>
        <p> {{ loader.mensaje }}</p>

      </div></template>
    <div>
      <b-alert
        variant="success"
        show
      >
        <div class="alert-body">
          <p><b> MODULO DE ENROLAMIENTO SALONES MOODLE </b></p>
        </div>
      </b-alert>
      <!-- Filters -->
      <filters
        v-show="!errorContent.filters"
        :status-filter.sync="configRequest.actividades"
        :status-filter2.sync="configRequest.cursos"
        :status-options="statusOptions"
        :status-options2="statusOptions2"
        :loader="loader.filters"
        @planfilter="configRequest.plan=$event"
        @periodofilter="configRequest.periodo= $event && $event.periodo ? $event.periodo : null, objperiodo=$event"
      />
      <b-alert
        v-if="objperiodo"
        variant="warning"
        show
      >
        <div class="alert-body">

          <b-form-checkbox
            v-model="enrolAutPeriodo"
            :unchecked-value="0"
            :value="1"
            switch
            @change="automatico(objperiodo.periodo, configRequest.plan)"
          >
            <p>Enrolamiento automatico para periodo: <b> {{ objperiodo.clave }} !Importante, no olvide desactivar esta opción, siempre y cuando el periodo del plan ya haya terminado. </b> </p>
          </b-form-checkbox>
        </div>
      </b-alert>
      <!-- Table Container Card -->
      <b-card
        v-show="!errorContent.table"
        no-body
        class="mb-0"
      >
        <!-- Datos cargados -->
        <b-card-header class="pb-0">
          <b-card-title />
          <b-card-text class="font-small-2 mr-25 mb-0">
            Datos cargados <b>{{ updatedAt }}</b>
          </b-card-text>
        </b-card-header>
        <!-- Table Top -->
        <div class="m-2">
          <b-row>
            <!-- Cantidad de elementos por página -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span>Mostrar</span>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
            </b-col>
            <!-- Buscador -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon
                      :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                      :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                      @click="searchQuery != '' ? searchQuery = '' : ''"
                    />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="searchQuery"
                    placeholder="Buscar por nombre del curso"
                  />
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-overlay
          rounded="sm"
          :show="isBusyTable"
          opacity="0"
        >
          <b-table
            ref="refDataListTable"
            class="position-relative"
            empty-text="No se encontraron resultados"
            primary-key="table_salones"
            responsive
            show-empty
            hover
            striped
            :items="fetchData"
            :fields="tableColumns"
            :sort-desc.sync="isSortDirDesc"
            :sort-by.sync="sortBy"
            @row-clicked="clickenrow"
          >
            <!-- colum: id moodle -->
            <template #cell(id)="data">
              <p>idMoodle: {{ data.item.id }}</p>
              <p class="text-primary">Periodo:
                <b>
                  {{ data.item.periodoClaveCampus }}</b></p>
              <p
                v-if="data.item.periodoCampus==null "
                class="text-danger"
              ><b> No existe una relación con CampusVirtual</b>
              </p>

            </template>
            <!-- Column: Course name -->
            <template #cell(shortname)="data">
              <h4>{{ data.item.fullname }}</h4>
              <p>
                Nombre Corto: <b class="text-primary">{{ data.item.shortname }}</b>
              </p>
              <small>
                Nombre mostrado: {{ data.item.displayname }}
              </small>
            </template>
            <!-- Column: startdate -->
            <template #cell(startdate)="data">
              <small><b>Inicio</b></small>
              <p v-if="data.item.startdate != 0">
                <b class="text-primary">{{ timestampToDate(data.item.startdate, 'L') }}</b>
              </p>
              <p v-if="data.item.startdate == 0">
                <b>Sin fecha</b>
              </p>
              <small><b>Último día</b></small>
              <p v-if="data.item.enddate != 0">
                <b>{{ timestampToDate(data.item.enddate, 'L') }}</b>
              </p>
              <p v-if="data.item.enddate == 0">
                <b>Sin fecha</b>
              </p>
              <small>Curso Visible</small>
              <p v-if="data.item.visible==1">
                <b class="text-primary">Si</b>
              </p>
              <p v-if="data.item.visible==0">
                <b lass="text-danger">No</b>
              </p>
              <small>Actividades Visibles</small>
              <p v-if="data.item.showactivitydates==true">
                <b class="text-primary">Si</b>
              </p>
              <p v-if="data.item.showactivitydates==false">
                <b class="text-danger">No</b>
              </p>
            </template>
            <!-- Column: numsections -->
            <template #cell(numsections)="data">
              <small>N° de Secciones</small>
              <p><b>{{ data.item.numsections }}</b></p>
              <small>Creado el</small>
              <p><b>{{ timestampToDate( data.item.timecreated, 'L' ) }}</b></p>
              <small>Modificado el</small>
              <p><b>{{ timestampToDate( data.item.timecreated, 'L') }}</b></p>
            </template>
            <!-- Column: summary -->
            <!-- eslint-disable vue/no-v-html -->
            <template #cell(summary)="data">
              <small><b>Plan de estudios: </b></small>
              <div v-html="data.item.nombre_plan" />
              <small><b>Descripción: </b></small>
              <div v-html="data.item.summary" />
            </template>
            <template #row-details="row">
              <hr>
              <div
                v-if="row.item.participantes"
                class="mx-5"
              >
                <b-row>
                  <b-col
                    cols="3"
                  >
                    <span><b class="text-primary">Participantes en ambas plataformas</b></span><br>

                    <app-collapse>

                      <app-collapse-item
                        v-for="participante in row.item.participantesCompletos"
                        :key="`ambas-plataformas-${participante.id}`"
                        :title="participante.fullname"
                      >
                        <p class="my-0">
                          <small><b>M: {{ participante.username }}</b></small>
                        </p>
                        <p class="my-0"><small>M: {{ participante.fullname }}</small>
                        </p>
                        <p>
                          <small>M: {{ participante.memail }}</small>
                        </p>
                        <p class="my-0">
                          <small>C: {{ participante.username }}</small>
                        </p>
                        <p class="my-0">
                          <small>C: {{ participante.nombre }}</small>
                        </p>
                        <p>
                          <small>C: {{ participante.email }}</small>
                        </p>
                        <p class="my-0">
                          <small>Moodle id: {{ participante.id }}</small>
                        </p>
                        <p class="my-0">
                          <small>Matricula {{ participante.matricula }}</small>
                        </p>
                        <p class="my-0">
                          <small>Periodo: {{ participante.periodo }}</small>
                        </p>
                        <div
                          v-for="rolmoodle in participante.roles"
                          :key="`enrol-${rolmoodle.shortname}`"
                        >
                          <small
                            :class="[rolmoodle.shortname == 'student' ? 'text-primary' : 'text-danger']"
                          ><b>{{ rolmoodle.shortname }}</b></small>
                        </div>
                      </app-collapse-item>

                    </app-collapse>
                  </b-col>
                  <b-col
                    cols="3"
                  >  <span><b class="text-primary">Participantes solo en Moodle</b></span><br>
                    <app-collapse v-if="row.item.participantes.alumnos">
                      <app-collapse-item
                        v-for="participante in row.item.participantes.alumnos"
                        :key="`participa-${participante.element.fullname}`"
                        :title="participante.element.fullname"
                      >
                        <p class="my-0">
                          <small><b>{{ participante.element.username }}</b></small>
                        </p>
                        <p class="my-0">
                          <small>Moodle id: {{ participante.element.id }}</small>
                        </p>
                        <div
                          v-for="rolmoodle in participante.element.roles"
                          :key="`id-moodle-${rolmoodle.shortname}`"
                        >
                          <small :class="[rolmoodle.shortname == 'student' ? 'text-primary' : 'text-danger']"><b>{{ rolmoodle.shortname }}</b></small>
                        </div>
                      </app-collapse-item>
                    </app-collapse>
                  </b-col>
                  <b-col
                    cols="3"
                  >
                    <span><b class="text-primary">Participantes solo en campus</b></span><br>
                    <ul class="list-group">
                      <b-card
                        class="my-1 text-center"
                        border-variant="secondary"
                      >
                        <b-button
                          block
                          class="font-weight-bold"
                          variant="outline-primary"
                          @click="getInfoParticipantes(row.item)"
                        >
                          <feather-icon
                            :id="`refresh-row-${row.item.index}-reload-icon`"
                            icon="RefreshCwIcon"
                          /> Recargar Lista
                        </b-button>
                      </b-card>
                      <b-card
                        class="my-1 text-center"
                        border-variant="secondary"
                      >
                        <p>Enrolar <b>{{ arrayEnrolPorCurso[row.item.id].length }}</b> alumnos seleccionados a : <b>"{{ row.item.fullname }}"</b></p>
                        <p class="my-1">
                          <b>periodo: {{ row.item.periodoClaveCampus }}</b>
                        </p>
                        <b-button
                          block
                          size="md"
                          class=""
                          @click.prevent="enrolarTodos
                            ({
                              curso:row.item.fullname,
                              id:row.item.id,
                              periodo: row.item.periodoCampus,
                              periodoClave: row.item.periodoClaveCampus,
                              item: row.item
                            })"
                        >Enrolar
                        </b-button>
                      </b-card>
                      <li
                        v-for="(participante, i) in row.item.participantesCampus"
                        :key="`solo-campus-${participante.persona_fk}-${i}`"
                      >
                        <p class="my-0">
                          <small><b>{{ participante.cuenta }}</b></small></p>
                        <p class="my-0">
                          <small>{{ participante.nombre }}</small>
                        </p>
                        <p class="my-0">
                          <small>{{ participante.email }}</small>
                        </p>
                        <p class="my-0">
                          <small>Matricula: {{ participante.matricula }}</small>
                        </p>
                        <small>Moolde id: {{ participante.moodle_id }}</small>
                        <div
                          v-if="participante.moodle_id!==null"
                          class="text-nowrap"
                        >
                          <b-form-checkbox
                            v-model="participante.checkboxrol"
                            unchecked-value="no"
                            value="si"
                            @change="agregarPersona({
                              participante: participante,
                              curso:{ id: row.item.id, nombre_curso: row.item.displayname },
                            },)"
                          ><small><b>Enrolar alumno {{ participante.checkboxrol }}</b></small>
                          </b-form-checkbox>
                          <b-button
                            variant="border-transparent"
                            class="text-primary"
                            size="sm"
                            @click.prevent="enrolar
                              ({
                                periodo: row.item.periodoClaveCampus,
                                item: row.item,
                                participante: participante,
                                curso:{ id: row.item.id, nombre_curso: row.item.displayname},
                              })"
                          >
                            <feather-icon
                              :id="`profesion-row-${participante.moodle_id}-editar`"
                              icon="CornerDownRightIcon"
                              class="text-primary"
                            />Clic para enrolar solo a este alumno.
                          </b-button>
                        </div>
                        <div
                          v-if="participante.moodle_id===null"
                          class="text-nowrap text-right"
                        >
                          <small class="text-danger">Este alumno no cuenta con id moodle</small>
                        </div>
                        <hr>
                      </li>
                    </ul>
                  </b-col>
                  <b-col
                    cols="3"
                  >  <span><b class="text-primary">Responsables en Moodle</b></span><br>
                    <ul class="list-group">
                      <li
                        v-for="participante in row.item.participantes.responsables"
                        :key="`responsables-${participante.element.fullname}`"
                      >
                        <p class="my-0">
                          <small><b>{{ participante.element.username }}</b></small></p>
                        <small>{{ participante.element.fullname }}</small>
                        <div
                          v-for="rolmoodle in participante.element.roles"
                          :key="`responsable-short-${rolmoodle.shortname}`"
                        >
                          <small
                            :class="[rolmoodle.shortname == 'student' ? 'text-primary' : 'text-danger']"
                          ><b>{{ rolmoodle.shortname }}</b></small>
                        </div>
                        <hr>
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </div>
            </template>
            <!-- Column: Opciones -->
            <template
              #cell(opciones)="data"
            >
              <div
                class="text-nowrap text-center"
              >
                <!-- Detalle -->
                <b-button
                  v-b-modal.modal-editarcurso
                  class="font-weight-bold"
                  variant="outline-primary"
                  @click="seleccionarrow({
                    periodo: data.item.periodoCampus,
                    materia_nombre: data.item.materia_nombre,
                    id_curso_campus: data.item.id_curso_campus,
                    mdl_id: data.item.mdl_id,
                    id:data.item.id,
                    nombre:data.item.fullname})"
                >
                  <feather-icon
                    :id="`salon-row-${data.index}-ver-icon`"
                    icon="Edit2Icon"
                  /> Editar
                </b-button>
                <br>
              </div>
            </template>
          </b-table>
        </b-overlay>
        <!-- Table's footer & pagination -->
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Leyenda de cuantos elementos se muestran -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} registros</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <!-- basic modal -->
      <b-modal
        id="modal-editarcurso"
        ref="modal-editarcurso"
        scrollable
        title="Editar Curso de Campus Virtual"
        size="lg"
        ok-only
        ok-title="Cerrar"
        button-size="sm"
      >
        <editarcurso
          :curso-data="selectRow"
        />
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BPagination,
  BCardHeader,
  BCardText,
  BCardTitle,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  VBModal,
  BModal,
  BFormCheckbox,
  BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  ref, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
import {
  lastUpdate,
  timestampToDate,
  nombreModalidad,
  avatarText,
} from '@core/utils/filter'
import store from '@/store'
import { configTableUsuarios, useUsuariosCatalogos } from '@/views/campus/adminMoodle/SalonesMoodle/useSalonesMoodle'
import { useFillDataTable } from '@core/components/data-table/useFillDataTable'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import editarcurso from '@/views/campus/adminMoodle/SalonesMoodle/components/editarCursoModal.vue'
import Ripple from 'vue-ripple-directive'
import { getData, postData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Filters from './components/Filters.vue'

export default {
  components: {
    BAlert,
    BButton,
    Filters,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardText,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    vSelect,
    BOverlay,
    AppCollapse,
    AppCollapseItem,
    BModal,
    editarcurso,
    BFormCheckbox,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      timestampToDate,
    }
  },
  setup() {
    const salonParticipantes = ref(null)

    const postDataEnrol = ref({})
    const nuevoArray = ref(null)
    const participantesCampus = ref(null)
    const participantesCompletos = ref(null)
    const toast = useToast()
    const arrayEnrolPorCurso = ref([])
    const selectRow = ref({})
    const vm = getCurrentInstance().proxy
    const objperiodo = ref(null)
    const enrolAutPeriodo = ref(null)
    const updatedAt = ref(lastUpdate())
    const loader = ref({ filters: false, screen: false, mensaje: '' })
    const errorContent = ref({ filters: false, table: false })
    const { tableColumns, configRequest } = configTableUsuarios()
    const { statusOptions, statusOptions2 } = useUsuariosCatalogos()
    const {
      fetchData, refetchData, refDataListTable,
      dataMeta,
      dynamicParamRequest,
      perPage, totalItems, currentPage, perPageOptions, searchQuery, sortBy, isSortDirDesc, dataAux,
      isBusyTable,
      errorRequest,
    } = useFillDataTable()
    isSortDirDesc.value = false

    const USER_APP_STORE_MODULE_NAME = 'app-user'
    //* On mounted
    const getEnrolAut = ((periodo, plan) => {
      const paramsRequest = {
        action: 32, plan, periodo, token: store.state.cuenta.session.token,
      }

      getData(paramsRequest, 'wsmoodleadmin')
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            enrolAutPeriodo.value = response.data.existe
          }
        })
        .catch(() => { enrolAutPeriodo.value = null })
    })

    const automatico = (periodo, plan) => {
      let mensaje = ''
      let pregunta = ''
      if (enrolAutPeriodo.value === 1) {
        pregunta = 'Mientras este activo, todos los alumnos que tengan una nueva agenda y esten dentro de las fechas del periodo  se enrolará automaticamente a todos los cursos que esten dados de alta en moodle y correspondan a su actual kardex</b>'
        mensaje = 'Si, Habilitar el Enrolamiento Automático!'
      } else {
        mensaje = 'Deshabilitar el Enrolamiento Automático!'
        pregunta = 'Dejara de enrolarse automaticamente los alumnos de este periodo y plan de estudios'
      }

      vm.$swal({
        title: '¿Estás seguro?',
        html: pregunta,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: mensaje,
        cancelButtonText: 'Cancelar!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          let accion = null
          if (enrolAutPeriodo.value === 1) accion = 33
          else accion = 34

          const params = new FormData()
          loader.value.screen = true
          loader.value.mensaje = 'Procesando enrolamiento automatico'
          params.append('task', 'wsmoodleadmin')
          params.append('origin', process.env.VUE_APP_ORIGIN_API)
          params.append('token', store.state.cuenta.session.token)
          params.append('action', accion)
          params.append('periodo', periodo)
          params.append('plan', plan)
          postData(params)
            .then(response => {
              if (response.data.status === 200) {
                vm.$swal({
                  icon: 'success',
                  title: 'Listo!',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                if (enrolAutPeriodo.value === 0) enrolAutPeriodo.value = 1
                else enrolAutPeriodo.value = 0
                vm.$swal({
                  icon: 'error',
                  title: 'ERROR',
                  html: 'No se realizo ninguna acción contacte a sistemas',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch(err => {
              if (enrolAutPeriodo.value === 0) enrolAutPeriodo.value = 1
              else enrolAutPeriodo.value = 0
              vm.$swal({
                icon: 'error',
                title: 'ERROR',
                html: `No se realizo ninguna acción contacte a sistemas : ${err}`,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .finally(() => {
              loader.value.screen = false
              loader.value.mensaje = ''
            })
        } else if (enrolAutPeriodo.value === 0) enrolAutPeriodo.value = 1
        else enrolAutPeriodo.value = 0
      })
    }

    const cancelarEnrolamiento = datos => {
      vm.$swal({
        title: 'Cancelado',
        html: `El alumno <b>${datos.participante.nombre}</b> con la matricula <b>${datos.participante.matricula}</b> NO fue enrolado al curso moodle <b>${datos.curso.nombre_curso}</b>, periodo <b>${datos.periodo}</b>`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    }

    const cancelarEnrolamientoTodos = datos => {
      vm.$swal({
        title: 'Cancelado',
        html: `Los alumnos NO fueron enrolados al curso moodle <b>${datos.curso}</b>, periodo <b>${datos.periodoClave}</b>`,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    }

    const seleccionarrow = datos => {
      selectRow.value = datos
    }

    const agregarPersona = datos => {
      const cursoId = datos.curso.id
      if (!arrayEnrolPorCurso.value[cursoId]) vm.$set(arrayEnrolPorCurso.value, cursoId, [])
      const found2 = arrayEnrolPorCurso.value[cursoId].findIndex(elemento => elemento.usuario === datos.participante.moodle_id)
      if (found2 === -1 && datos.participante.checkboxrol === 'si') arrayEnrolPorCurso.value[cursoId].push({ usuario: datos.participante.moodle_id, curso: cursoId })
      else arrayEnrolPorCurso.value[cursoId].splice(found2, 1)
    }

    const comparar = (datos1, datos2) => Array.from(new Set(datos1.map(d => d.element.id).filter(e => new Set(datos2.map(d => d.moodle_id)).has(e))))

    const getInfoParticipantes = item => {
      const { index } = item
      const z = []
      let x = {}
      let y = {}
      let periodoCampusVirtual = item.periodoCampus
      if (periodoCampusVirtual == null) periodoCampusVirtual = 0
      vm.$set(arrayEnrolPorCurso.value, item.id, [])
      salonParticipantes.value = []
      participantesCampus.value = []
      loader.value.screen = true
      loader.value.mensaje = 'Actualizando lista de alumnos.'
      Promise.all([store.dispatch('salonesMoodle/fetchSalonMoodle', { id: item.id }), store.dispatch('salonesMoodle/fetchParticipantesXidMoodle', { id: item.id, periodo: periodoCampusVirtual })]).then(values => {
        [salonParticipantes.value, participantesCampus.value] = values
        try {
          nuevoArray.value = comparar(salonParticipantes.value.alumnos, participantesCampus.value)
          nuevoArray.value.forEach(element => {
            x = salonParticipantes.value.alumnos.filter(alumnito => alumnito.element.id === element)
            const borraconindexmoodle = salonParticipantes.value.alumnos.findIndex(alumnito => alumnito.element.id === element)
            y = participantesCampus.value.filter(alumnito => alumnito.moodle_id === element)
            const borraconindexcampus = participantesCampus.value.findIndex(alumnito => alumnito.moodle_id === element)
            z.push({
              fullname: x[0].element.fullname,
              memail: x[0].element.email,
              username: x[0].element.username,
              roles: x[0].element.roles,
              id: x[0].element.id,
              periodo: y[0].periodo,
              nombre: y[0].nombre,
              matricula: y[0].matricula,
              email: y[0].email,
            })
            participantesCampus.value.splice(borraconindexcampus, 1)
            salonParticipantes.value.alumnos.splice(borraconindexmoodle, 1)
          })
          dataAux.value[index].participantesCompletos = z
          dataAux.value[index].participantes = salonParticipantes.value
          dataAux.value[index].participantesCampus = participantesCampus.value

          participantesCampus.value.forEach(par => {
            arrayEnrolPorCurso.value[item.id].push({ usuario: par.moodle_id, curso: item.id })
            // eslint-disable-next-line no-param-reassign
            par.checkboxrol = 'si'
          })
          // }
        } catch (e) {
          toast({
            component: ToastificationContent,
            props: {
              title: `Error de sincronización vue ${e}`,
              variant: 'danger',
              solid: true,
            },
          },
          { timeout: 10000 })
        } finally {
          loader.value.screen = false
          loader.value.mensaje = ''
        }
      }, reason => {
        loader.value.screen = false
        loader.value.mensaje = ''
        salonParticipantes.value = undefined
        participantesCampus.value = undefined
        participantesCompletos.value = undefined

        toast({
          component: ToastificationContent,
          props: {
            title: `Error en solicitud ${reason}`,
            variant: 'danger',
            solid: true,
          },
        },
        { timeout: 10000 })
      })
    }

    const clickenrow = item => {
      // eslint-disable-next-line no-underscore-dangle
      vm.$set(item, '_showDetails', !item._showDetails)

      // eslint-disable-next-line no-underscore-dangle
      if (item._showDetails && (dataAux.value[item.index].participantes === undefined && dataAux.value[item.index].participantesCampus === undefined && dataAux.value[item.index].participantesCompletos === undefined)) getInfoParticipantes(item)
    }

    const enrolar = datos => {
      vm.$swal({
        title: '¿Estás seguro?',
        html: `<b>${datos.participante.nombre}</b> con la matricula <b>${datos.participante.matricula}</b> se enrolará al curso moodle <b>${datos.curso.nombre_curso}</b>, periodo <b>${datos.periodo}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Enrolar!',
        cancelButtonText: 'No Cancelar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          postDataEnrol.value.curso = datos.curso.id
          postDataEnrol.value.usuario = datos.participante.moodle_id

          const params = new FormData()
          loader.value.screen = true
          loader.value.mensaje = 'Enrolando al alumno.'
          params.append('task', 'wsmoodleadmin')
          params.append('origin', process.env.VUE_APP_ORIGIN_API)
          params.append('token', store.state.cuenta.session.token)
          params.append('action', 22)
          params.append('datos', JSON.stringify(postDataEnrol.value))
          postData(params)
            .then(response => {
              if (response.data.status === 200) {
                vm.$swal({
                  icon: 'success',
                  title: 'Enrolado!',
                  html: `El alumno <b>${datos.participante.nombre}</b> con la matricula <b>${datos.participante.matricula}</b> fue enrolado al curso moodle <b>${datos.curso.nombre_curso}</b>, periodo <b>${datos.periodo}</b>`,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                vm.$swal({
                  title: 'Cancelado',
                  html: `Interrupcion del serivicio:  mensaje ${response.data.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch(err => {
              cancelarEnrolamiento(datos)
            })
            .finally(() => {
              loader.value.screen = false
              loader.value.mensaje = ''
              getInfoParticipantes(datos.item)
            })
        } else if (result.dismiss === 'cancel') cancelarEnrolamiento(datos)
      })
    }

    const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel, curso, periodo) => {
      // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
      let CSV = ''
      let claves
      let row = ''

      // This condition will generate the Label/Header
      if (ShowLabel) {
        // This loop will extract the label from 1st index of on array
        claves = Object.keys(arrData[0])
        row = JSON.stringify(claves)
        row = row.substring(1, row.length - 1)
        // hasta aqui estan los titulos separados por comas
        CSV = `${row}\r\n`
      }
      let rows = ''
      const valorTempClaves = claves
      // // 1st loop is to extract each row
      for (let index = 0; index < arrData.length; index += 1) {
        rows = ' '
        for (let i = 0; i < valorTempClaves.length; i += 1) {
        // 2nd loop will extract each column and convert it in string comma-separated
          rows += `${arrData[index][valorTempClaves[i]]},`
        }
        CSV += `${rows}\r\n`
      }
      if (CSV === '') {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'La consulta no genera ningún dato',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      } else {
      // Generate a file name
        let fileName = `Logs_Enrolamiento_${curso}_${periodo}`
        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, '_')
        // Initialize file format you want csv or xls
        const uri = `data:text/xlsx;charset=utf-8,${escape(CSV)}",`// 'data:text/csv;charset=utf-8,' + escape(CSV);
        const link = document.createElement('a')
        link.href = uri
        // set the visibility hidden so it will not effect on your web-layout
        link.style = 'visibility:hidden'
        document.style = 'color:black'
        link.download = `${fileName}.csv` // fileName + '.csv'
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención',
            text: 'Revise los logs generados',
            icon: 'AlertCircleIcon',
            variant: 'success',
          },
        },
        { timeout: 10000 })
      }
    }

    const enrolarTodos = datos => {
      vm.$swal({
        title: '¿Estás seguro?',
        html: `Enrolar a los <b>${arrayEnrolPorCurso.value[datos.id].length}</b> alumnos seleccionados al curso moodle <b>${datos.curso}</b>, periodo <b>${datos.periodoClave}</b>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, Enrolar!',
        cancelButtonText: 'No Cancelar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          const postDataEnrollTodos = { elementos: arrayEnrolPorCurso.value[datos.id] }

          const params = new FormData()
          loader.value.screen = true
          loader.value.mensaje = 'Enrolando la lista de alumnos.'
          params.append('task', 'wsmoodleadmin')
          params.append('origin', process.env.VUE_APP_ORIGIN_API)
          params.append('token', store.state.cuenta.session.token)
          params.append('action', 21)
          params.append('datos', JSON.stringify(postDataEnrollTodos))
          postData(params)
            .then(response => {
              if (response.data.status === 200) {
                vm.$swal({
                  icon: 'success',
                  title: 'Proceso Terminado!',
                  html: `Proceso terminado para el curso moodle <b>${datos.curso}</b>, periodo <b>${datos.periodoClave}</b>. Por favor lea los logs generados.`,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
                const selectedrow = dataAux.value.findIndex(cursos => cursos.id === datos.id)

                dataAux.value[selectedrow].participantesCampus = undefined
                dataAux.value[selectedrow].participantesCompletos = undefined
                dataAux.value[selectedrow].participantes = undefined

                const diActual = timestampToDate(Math.floor(Date.now() / 1000))
                JSONToCSVConvertor(response.data.log, diActual, true, datos.curso, datos.periodoClave)
              } else {
                vm.$swal({
                  title: 'Cancelado',
                  html: `Interrupcion del serivicio <b>${datos.curso}</b>, periodo <b>${datos.periodoClave}</b> mensaje ${response.data.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch(err => {
              cancelarEnrolamientoTodos(datos)
            })
            .finally(() => {
              loader.value.screen = false
              loader.value.mensaje = ''
              getInfoParticipantes(datos.item)
            })
        } else if (result.dismiss === 'cancel') cancelarEnrolamientoTodos(datos)
      })
    }

    onMounted(() => {
      dynamicParamRequest.value = configRequest.value //* Asign config params for each module as dynamic params
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
    watch(errorRequest, error => { if (error) errorContent.value.table = error }) //* If the flag 'errorRequest' from data request is true, hide table content
    watch(configRequest.value, () => { refetchData() }) //* Any change in config params (filters), refetch table data

    watch(objperiodo, () => {
      if (objperiodo.value && objperiodo.value.periodo) getEnrolAut(objperiodo.value.periodo, configRequest.value.plan)
      else enrolAutPeriodo.value = null
    })

    return {
      fetchData,
      dataAux,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      // Filter
      lastUpdate,
      updatedAt,
      timestampToDate,
      nombreModalidad,
      avatarText,
      automatico,
      cancelarEnrolamiento,
      cancelarEnrolamientoTodos,
      seleccionarrow,
      selectRow,
      agregarPersona,
      arrayEnrolPorCurso,
      comparar,
      clickenrow,
      enrolar,
      enrolarTodos,
      getInfoParticipantes,
      salonParticipantes,
      postDataEnrol,
      nuevoArray,
      participantesCampus,
      participantesCompletos,
      // Filter's option
      statusOptions,
      statusOptions2,
      // Extra Filters
      configRequest,
      // Loader
      loader,
      isBusyTable,
      // Error
      errorContent,
      objperiodo,
      enrolAutPeriodo,
    }
  },

}
</script>
<style>
[class*=collapse-] .collapse-title {
    font-weight: 500;
    font-size: 1rem;
}
[dir=ltr] [class*=collapse-] .card .card-header {
    padding: 0 2.8rem 0 0;
}
#overfix .position-absolute {
  position: fixed !important;
}
</style>
